import React from "react";
import PropTypes from "prop-types";
import { Progress } from "antd";
import "styles/loader-skeleton.css";

class LoaderSkeleton extends React.Component {
    childRef = React.createRef();
    render() {
        if (this.props.loading) {
            return (
                <div
                    className={
                        "d-flex h-100 justify-content-center align-items-center"
                    }
                >
                    <div
                        style={{
                            width: 300
                        }}
                    >
                        <Progress
                            percent={50}
                            status="active"
                            showInfo={false}
                        />
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

LoaderSkeleton.propTypes = {
    loading: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

LoaderSkeleton.defaultProps = {
    loading: true
};

export default LoaderSkeleton;
